import { makeStyles } from "@mui/styles";

const interactiveViewersStyle = makeStyles((theme) => ({
  container: {
    paddingLeft: '7rem',
    paddingRight: '7rem',
    paddingTop: '40px !important',
    width: "100%",
    boxSizing:"border-box",
    backgroundColor: theme.palette.background.gray,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '6rem',
      paddingRight: '6rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      alignItems: "center",
    },
  },

  underline: {
    width: "100%",
    height: "2px",
    backgroundColor: "#ddd",
    alignSelf: "flex-end",
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
    },
  },

}));

export default interactiveViewersStyle;